import _ from 'lodash'

const state = {
    paymentMethods: [
        // NOTE: The list of kaoshi p2p payment method type used
        // This code is symetrical to constants in  `services/orders/index.js`
        // Maybe we should receive all this list from servers both for kaoshi-api and scrapper-api
        {
            name: 'P2P Bank Transfer',
            icon: 'mdi-bank-outline',
            methods: [
                'paypal_payment',
                'nigerian_bank_payment',
                'interac_payment',
                'zelle_payment',
                'mtn_mobile_payment',
                'airtel_mobile_payment',
                'ghana_bank_payment',
                'sepa_payment',
                'faster_payment',
            ],
        },
        {
            name: 'ACH',
            icon: 'mdi-bank-outline',
            methods: [
                'BANK_DEPOSIT',
                'BANK_TRANSFER',
                'BALANCE',
                'BANKGIRO',
                'DIRECT_DEBIT',
                'IDEAL',
                'OSKO',
                'PAYNOW',
                'PISP',
                'POLI',
                'SOFORT',
                'TRUSTLY',
                'BANK_ACCOUNT',
                'PAYPAL_BALANCE',
            ],
        },
        {
            name: 'Debit card',
            icon: 'mdi-credit-card-outline',
            methods: [
                'DEBIT_CARD',
                'DC',
                'CARD',
                'DEBIT',
                'GOOGLE_PAY',
                'INT_DEBIT_WITH_EUROPEAN_CARD',
                'INTERNATIONAL_DEBIT',
                'MAESTRO',
                'MC_BUSINESS_DEBIT',
                'MC_DEBIT_OR_PREPAID',
                'VISA_BUSINESS_DEBIT',
                'VISA_DEBIT_OR_PREPAID',
            ],
        },
        {
            name: 'Credit card',
            icon: 'mdi-credit-card-outline',
            methods: [
                'CC',
                'CREDIT_CARD',
                'APPLE_PAY',
                'CREDIT',
                'INT_CREDIT_WITH_EUROPEAN_CARD',
                'INTERNATIONAL_CREDIT',
                'MC_BUSINESS_CREDIT',
                'MC_CREDIT',
                'VISA_BUSINESS_CREDIT',
                'VISA_CREDIT',
            ],
        },
        {
            name: 'Wire transfer',
            icon: 'mdi-bank-outline',
            methods: [
                'SWIFT',
            ],
        },
        {
            name: 'Cash drop-off',
            icon: 'mdi-cash',
            methods: [
                'CASH',
                'BOLETO',
            ],
        },
    ],
}

const getters = {
	paymentMethods: ({ paymentMethods }) => paymentMethods,
}

export default {
	namespaced: true,
	state,
	getters,
}
